<div *ngIf="chumon">
  <h3>注文追加</h3>
  <div fxLayout="column wrap" fxLayoutGap="16px">
    <form #form="ngForm">
      <div fxLayout="row wrap" fxLayoutGap="24px">
        <ng-select class="input-width"
                   [items]="masterService.shukkaSakiMaster | isDeletedFilter:false"
                   bindLabel="name"
                   bindValue="id"
                   placeholder="出荷先*"
                   required
                   appendTo="body"
                   [closeOnSelect]="true"
                   [multiple]="false"
                   [(ngModel)]="chumon.shukkaSakiId"
                   name="shukkaSakiId">
        </ng-select>
        <ng-select class="input-width"
                   [items]="masterService.keishuMaster | isDeletedFilter:false"
                   bindLabel="name"
                   bindValue="id"
                   placeholder="鶏種*"
                   required
                   appendTo="body"
                   [closeOnSelect]="true"
                   [multiple]="false"
                   [(ngModel)]="chumon.keishuId"
                   name="keishuId">
        </ng-select>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="24px">
        <mat-form-field appearance="legacy" class="input-width">
          <mat-label>餌付日</mat-label>
          <input matInput
                 [matDatepicker]="yoteiEdukeDatePicker"
                 [(ngModel)]="chumon.edukeDate"
                 name="yoteiEdukeDate"
                 readonly
                 required
                 (click)="yoteiEdukeDatePicker.open()"
                 (dateChange)="chumonService.updateYoteiShukkaDate($event.value, chumon)">
          <mat-datepicker-toggle matSuffix [for]="yoteiEdukeDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #yoteiEdukeDatePicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="legacy" class="input-width">
          <mat-label>予定出荷日</mat-label>
          <input matInput
                 [matDatepicker]="yoteiShukkaDatePicker"
                 [(ngModel)]="chumon.yoteiShukkaDate"
                 name="yoteiShukkaDate"
                 required
                 readonly
                 (click)="yoteiShukkaDatePicker.open()">
          <mat-datepicker-toggle matSuffix [for]="yoteiShukkaDatePicker"></mat-datepicker-toggle>
          <mat-datepicker touchUi #yoteiShukkaDatePicker></mat-datepicker>
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="24px">
        <mat-form-field class="input-width">
          <mat-label>
            羽数
          </mat-label>
          <input matInput required placeholder="羽数" type="text" inputmode="numeric" step="1" min="0"
                 name="wasuu" [(ngModel)]="chumon.wasuu" #wasuuModel="ngModel"
                 [errorStateMatcher]="wasuuErrorStateMatcher" integerOnly>
          <mat-error *ngIf="wasuuModel.hasError('integerOnly')">羽数は整数で入力してください。</mat-error>
        </mat-form-field>
        <mat-form-field class="input-width">
          <mat-label>
            担当者
          </mat-label>
          <input matInput placeholder="担当者"
                 name="tantousha" [(ngModel)]="chumon.tantousha">
        </mat-form-field>
      </div>
      <div fxLayout="row wrap" fxLayoutGap="24px">
        <mat-form-field style="width: 100%">
          <mat-label>
            メモ
          </mat-label>
          <textarea matInput
                    name="memo"
                    [(ngModel)]="chumon.memo"
                    placeholder="メモ"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="3"
                    cdkAutosizeMaxRows="10">
                  </textarea>
        </mat-form-field>
      </div>
    </form>
    <div [matTooltip]="commonService.getAlertTooltipMessage(form)"
         matTooltipPosition="right"
         style="width: fit-content">
      <button mat-raised-button color="primary"
              [disabled]="form.invalid || !form.dirty"
              (click)="register()">登録
      </button>
    </div>
  </div>
</div>
